import Vue from 'vue'
import { notification } from 'ant-design-vue'

const copyToClipboard = async (value, message = '') => {
  if (!value?.length) {
    return
  }

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(value)
    } else {
      Vue.prototype.$clipboard(value)
    }

    if (message?.length) {
      notification.success({ message })
    }
  } catch (err) {
    notification.error({
      message: 'Не удалось скопировать',
      description: err.message,
    })
  }
}

export { copyToClipboard }
